export default __webpack_public_path__ + "static/Me-e080cd6cba30f9bfc23d6bc48f19ede1.png";